<template>
  <base-layout title="Exams">
    <ion-grid fixed>
      <ion-row>
        <ion-col size="12">
          <ion-list>
            <ion-item
              :router-link="{ name: p.routeName }"
              v-for="(p, i) in appPages"
              :key="i"
              class="link"
            >
              <ion-icon slot="start" :ios="p.iosIcon" :md="p.mdIcon"></ion-icon>
              <ion-label>
                <h2>{{ p.title }}</h2>
                <p>{{ p.description }}</p>
              </ion-label>
            </ion-item>
          </ion-list>
        </ion-col>
      </ion-row>
    </ion-grid>
  </base-layout>
</template>

<script>
import BaseLayout from "../../Base/BaseLayout.vue";
import {
  IonGrid,
  IonRow,
  IonCol,
  IonList,
  IonItem,
  IonIcon,
  IonLabel,
} from "@ionic/vue";

import { bookOutline, bookSharp } from "ionicons/icons";

export default {
  components: {
    BaseLayout,
    IonGrid,
    IonRow,
    IonCol,
    IonList,
    IonItem,
    IonIcon,
    IonLabel,
  },
  data() {
    return {
      appPages: [
        {
          title: "View Exams",
          description: "View, modify and delete exams",
          routeName: "exam.list",
          iosIcon: bookOutline,
          mdIcon: bookSharp,
        },
        {
          title: "Create Exam",
          description: "Create online and offline exams",
          routeName: "exam.create",
          iosIcon: bookOutline,
          mdIcon: bookSharp,
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>
